import { Grid, Paper, TextField, Typography } from "@mui/material";
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import img from './imgs/removebg.png';
import background from './imgs/almostremovedbackground.png';
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../firebase/Firebase";
import { useAuth } from "../context/AuthContext";
import api from "../api";
export default function SignUp() {

    var navi = useNavigate();

    var url = `http://localhost:${process?.env.PORT || 3000}/`;

    function initializeRecaptcha() {

        if (!window.recaptchaVerifier) {

            window.recaptchaVerifier = new RecaptchaVerifier(
                auth,
                "recaptcha-container",
                {
                    size: "invisible",

                    callback: () => {
                        console.log("Recaptcha Verified");
                    }
                }
            );

        }

    }

    const [loading, setLoading] = useState(false);

    async function addUser(e) {

        e.preventDefault();

        const data = new FormData(e.currentTarget);

        const phone = data.get("phone");

        setSignupData({
            firstName: data.get("fname"),
            lastName: data.get("lname"),
            email: data.get("email"),
            password: data.get("password"),
            phone
        });

        axios.post(url + 'user/signup', {
            firstName: data.get('fname'),
            lastName: data.get('lname'),
            email: data.get('email'),
            password: data.get('password'),
            phone
        }).then((succ) => {
            setLoading(false);
            if (succ.data.reponse == 'failed') {
                alert(succ.data.reason)
            } else {
                alert('worked!');
                localStorage.setItem('userId', succ.data.id);
                console.log(succ.data)
            }
        })

        // try {

        //     setLoading(true);

        //     initializeRecaptcha();

        //     const appVerifier = window.recaptchaVerifier;

        //     const confirmation =
        //         await signInWithPhoneNumber(
        //             auth,
        //             "+91" + phone,
        //             appVerifier
        //         );

        //     setConfirmationResult(confirmation);

        //     setOtpSent(true);

        //     alert("OTP sent successfully.");

        // }
        // catch (err) {

        //     console.log(err);

        //     alert(err.message);

        // }

        // finally {

        //     setLoading(false);

        // }



    }

    // const [user,setUser] = useS
    const { user, setUser } = useAuth();

    async function logIn(e) {
        e.preventDefault();
        var formdata = new FormData(e.currentTarget);

        const response = await api.post(url + 'user/signin', {
            phone: Number(formdata.get('phone')),
            password: formdata.get('password')
        });
        var data = response.data
        if (data.response == 'failed') {
            alert(data.reason)
        } else {
            localStorage.setItem('access_token', data.access_token);
            localStorage.setItem('refresh_token', data.refresh_token);
        }
        const user = await api.get("/auth/me");
        setUser(user.data);
        navi("/");
        // .then((succ) => {
        //     var data = succ.data
        //     if (data.response == 'failed') {
        //         alert(data.reason);
        //     } else {
        //         localStorage.setItem('access_token', data.access_token);
        //         localStorage.setItem('refresh_token', data.refresh_token);
        //         // navi('/')
        //     }
        // })

    }

    const [hidden, sethidden] = useState(true);
    const [login, setlogin] = useState(false);

    const [otpSent, setOtpSent] = useState(false);

    const [otp, setOtp] = useState("");

    const [confirmationResult, setConfirmationResult] = useState(null);

    const [signupData, setSignupData] = useState(null);


    const [headings, setheadings] = useState([]);
    function fetchHeadings() {
        // axios.post(url + 'fetchHeadings', {
        //     PageName: 'List Your Business'
        // }).then((succ) => {
        //     setheadings(succ.data.Headings);
        //     console.log(succ.data.Headings);
        // })
    }
    useEffect(() => {
        fetchHeadings();
    }, [])

    async function verifyOTP() {

        if (!otp.trim()) {
            alert("Please enter OTP.");
            return;
        }

        try {

            setLoading(true);

            const result = await confirmationResult.confirm(otp);

            const firebaseToken = await result.user.getIdToken();

            const response = await axios.post(
                url + "user/signup",
                {
                    ...signupData,
                    firebaseToken
                }
            );

            if (response.data.response === "failed") {

                alert(response.data.reason);
                return;

            }

            localStorage.setItem(
                "useruid",
                response.data.id
            );

            navi("/");

        }

        catch (err) {
            console.log(err);
            if (err.code === "auth/invalid-verification-code") {
                alert("Incorrect OTP.");
            }
            else if (err.code === "auth/code-expired") {
                alert("OTP expired.");
            }
            else {
                alert(err.message);
            }
        }

        finally {
            setLoading(false);
        }
    }


    return (

        <Grid className='admin-bod' width={'100%'}>
            {/* <Navbar /> */}
            {/* <div id="recaptcha-container"></div> */}
            {/* {con ? (
                            <></>
                            // <form onSubmit={subotp}>

                            // <TextField type="password" margin="normal" size="small" label="Otp" name="otp" fullWidth />
                            // <button className="mt-3 btn-navy" type="submit" >Submit Otp </button>
                            // </form>
                        ) : ( */}

            {/* <TextField defaultValue={'Rishabh'} fullWidth size="small" className="mt-3" name="oname" label={"Owner's Name"} />
                                    <TextField defaultValue={'Siam Wellness Centre and Family Spa'} fullWidth size="small" className="mt-2" name="name" label={"Shop Name"} />
                                    <TextField defaultValue={'Sector 9 Panchkula,Haryana,India'} fullWidth size="small" className="mt-2" name="address" label={"Address"} />
                                    <TextField defaultValue={'naksh@gmail.com'} fullWidth size="small" type="email" className="mt-2" name="email" label={"Email"} />
                                    <TextField defaultValue={'9779029290'} fullWidth size="small" type="tel" className="mt-2" name="phone" label={"Phone no."} />
                                    <TextField defaultValue={'naksh'} fullWidth size="small" className="mt-2" name="username" label={"Username"} />
                                    <TextField defaultValue={'12345678'} fullWidth type="password" size="small" className="mt-2" name="password" label={"Password"} /> */}
            {/* <Grid bgcolor={''}></Grid> */}
            {/* <input type="text" placeholder="Username" className="form-control py-2 mt-2" /> */}
            <Grid height={'100vh'}
                sx={{
                    // background: 'url("https://t3.ftcdn.net/jpg/01/28/40/94/360_F_128409476_MjNDWNfvtj4itt1Xn0kxDm4b16G1bepn.jpg")',
                    background: `url(${background})`,
                    backgroundSize: "contain", backgroundRepeat: 'no-repeat', backgroundPosition: 'right'
                }}
                width={'100%'} margin={'auto'} container justifyContent={'center'} alignItems={'center'}>
                <Typography lineHeight={.2} mt={2} variant="h3" fontWeight={'bold'} className="w-100 text-center" p={0}>{headings[0]?.content || 'Join us to change your life!'}</Typography>
                <Typography lineHeight={0.12} mt={-5} variant="h6" fontWeight={500} className="w-100 text-center" p={0}>{headings[1]?.content || 'Earn more. Earn respect. Safety Ensured'}</Typography>
                <Grid border={'1px solid black'} size={{ lg: 9 }} container bgcolor={'white'} borderRadius={3}
                // overflow={'hidden'}
                >
                    <Grid container className='go-to-login' justifyContent={'center'} alignItems={'center'} size={{ lg: 6 }}
                        sx={{ transform: `translateX(${login && '100%'})` }}
                    >

                        {!login ? (
                            <Grid size={{ lg: 9 }}>
                                <Grid className="p-3 bg-transparent w-100">
                                    <Typography variant="h4" textAlign={'center'}>{headings[2]?.content || 'Sign Up'}</Typography>

                                    <form onSubmit={addUser} className="w-100">
                                        <input disabled={otpSent} name="fname" type="text" placeholder="First Name" className="form-control py-2 mt-5" />
                                        <input disabled={otpSent} name="lname" type="text" placeholder="Last Name" className="form-control py-2 mt-2" />
                                        {/* <input name="name" type="text" placeholder="Salon Name" className="form-control py-2 mt-2" /> */}
                                        {/* <input name="address" type="text" placeholder="Address" className="form-control py-2 mt-2" /> */}
                                        {/* <input name="username" type="text" placeholder="Username" className="form-control py-2 mt-2" /> */}
                                        <input disabled={otpSent} name="email" type="email" placeholder="Email" className="form-control py-2 mt-2" />
                                        <input disabled={otpSent} name="phone" type="number" inputMode="numeric" pattern="[0-9*]" min={1000000000} placeholder="Mobile number" className="form-control py-2 mt-2" />
                                        <div className="input-group mt-2">
                                            <input disabled={otpSent} name="password" type={hidden ? 'password' : 'text'} placeholder="Password" className="form-control py-2" />
                                            {
                                                otpSent && (

                                                    <input

                                                        type="text"

                                                        placeholder="Enter OTP"

                                                        className="form-control py-2 mt-2"

                                                        value={otp}

                                                        onChange={(e) => setOtp(e.target.value)}

                                                    />

                                                )
                                            }
                                            <button type="button" onClick={() => sethidden(!hidden)} className="btn-admin-navy px-4">{hidden ? <Visibility /> : <VisibilityOff />}</button>
                                        </div>
                                        {/* <button type="submit" className="btn-admin-navy py-2  rounded mt-2 w-100">Sign Up</button> */}
                                        {
                                            !otpSent ?

                                                <button
                                                    type="submit"
                                                    disabled={loading}
                                                    className="btn-admin-navy py-2 rounded mt-2 w-100">

                                                    {
                                                        loading ?

                                                            "Sending OTP..."

                                                            :

                                                            "Send OTP"

                                                    }

                                                </button>

                                                :

                                                <button
                                                    type="button"
                                                    onClick={verifyOTP}
                                                    disabled={loading}
                                                    className="btn-admin-navy py-2 rounded mt-2 w-100"
                                                >

                                                    {
                                                        loading
                                                            ? "Verifying..."
                                                            : "Verify OTP"
                                                    }

                                                </button>

                                        }
                                        <div id="recaptcha-container"></div>
                                    </form>
                                </Grid>
                            </Grid>
                        ) : (

                            <Grid size={{ lg: 10 }}>
                                <Grid className="px-2 py-4 col-12 bg-transparent">
                                    <Typography variant="h4">{headings[3]?.content || 'Sign In'}</Typography>

                                    <form onSubmit={logIn}>
                                        <input type="text" placeholder="Phone" name="phone" className="form-control py-2 mt-3" />
                                        <div className="input-group mt-2">
                                            <input type={hidden ? 'password' : 'text'} name="password" placeholder="Password" className="form-control py-2" />
                                            <button type="button" onClick={() => sethidden(!hidden)} className="btn-admin-navy px-4">{hidden ? <Visibility /> : <VisibilityOff />}</button>
                                        </div>
                                        <button className="btn-admin-navy py-2 mt-2 col-12" type="submit">Sign in</button>


                                        {/* <button type="submit" className="btn-admin-navy py-2  rounded mt-2 w-100">Register</button> */}
                                    </form>
                                </Grid>
                            </Grid>

                        )}
                    </Grid>
                    <Grid size={{ lg: 6 }}
                        className='go-to-reg'
                        alignItems="center"
                        sx={{ transform: `translateX(${login && '-100%'})` }}
                        justifyContent="center" container minHeight={'40vh'}
                        // sx={{ background: 'linear-gradient(to left,rgb(0,0,0,.5),rgb(0,0,0,.5)),url("https://mail.google.com/mail/u/0?ui=2&ik=72fb09ea8d&attid=0.1&permmsgid=msg-f:1862475103316476993&th=19d8d73d18300441&view=fimg&fur=ip&permmsgid=msg-f:1862475103316476993&sz=s0-l75-ft&attbid=ANGjdJ-rYmk3tiGVc3RBmWsi7CtqFGonsuV-5Nu7B0aeY1z9r5cmrlwY8luNI0rTBUMZTUpV-SYtsFK88YyaYMhOJdPeynVbouZgSBbit6uw27WYxNWTpxhfN8VFJU4&disp=emb&realattid=ii_mnz0fkeb0&zw")', backgroundSize: 'cover' }}
                        borderLeft={'1px solid black'}>
                        {/* <img src="https://urbanclap-prod.s3-ap-southeast-1.amazonaws.com/categories/category_v2/partner_hero_india_cover.png" className="img-fluid listImg" /> */}
                        {/* <img src={img} className="img-fluid listImg" /> */}
                        {/* {!login && ( */}
                        <>
                            <img src="https://msfbarbershop.com/cdn/shop/files/Barber-shop-logo-on-transparent-background-PNG-removebg-preview.png?v=1739271148" className="" style={{ width: 200, marginTop: -120, filter: 'invert(100%)' }} />
                        </>

                        {!login ? (
                            <Grid className="w-100">
                                <center>
                                    <div className="col-lg-8">
                                        <Typography variant="h4" className="">Welcome Back!!!</Typography>
                                        <Typography variant="body1" className="mt-2">Already have an account?</Typography>
                                        <button className="btn-outline-white text-white btn mt-3 rounded-pill col-12" onClick={() => setlogin(!login)}>Sign in</button>
                                        {/* <button onClick={() => setlogin(!login)} className="btn-outline-admin-navy-hover mt-3 rounded-pill col-12">Log in</button> */}
                                        {/* <button className="btn-outline-light btn mt-3 rounded-pill col-12">Register</button> */}
                                    </div>
                                </center>
                            </Grid>
                        ) : (
                            <Grid className="w-100 z-5 ">
                                <center>
                                    <div className="col-lg-8">
                                        <Typography variant="h4" className="">Hello There,</Typography>
                                        <Typography variant="body1" className="mt-2">dont have an account?</Typography>
                                        <button onClick={() => setlogin(!login)} className="btn-outline-white mt-3 rounded-pill col-12">Sign Up</button>
                                    </div>
                                </center>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                {/* <button type="button" onClick={() => abc()} className="btn-navy py-2 rounded mt-2 w-100">Register</button> */}
                {/* <img src='https://images.unsplash.com/photo-1585747860715-2ba37e788b70?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFyYmVyc2hvcHxlbnwwfHwwfHx8MA%3D%3D' className="img-fluid rounded col-7" /> */}

            </Grid>

            <Footer />
        </Grid>



    )


}